import React, { useState } from 'react';
import ThemeSwitcher from '../ThemeSwitcher';
import { Link,useLocation } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const location = useLocation();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  const NavLinks = () => (
    <>
      <Link
        to='/'
        className={`nav-link text-gray-900 dark:text-white ${location.pathname === '/' ? 'active' : ''}`}
        onClick={() => setIsDrawerOpen(false)}
      >
        Home
      </Link>
      <Link
        to='/about'
        className={`nav-link text-gray-900 dark:text-white ${location.pathname === '/about' ? 'active' : ''}`}
        onClick={() => setIsDrawerOpen(false)}
      >
        About
      </Link>
      <Link
        to='/projects'
        className={`nav-link text-gray-900 dark:text-white ${location.pathname === '/projects' ? 'active' : ''}`}
        onClick={() => setIsDrawerOpen(false)}
      >
        Projects
      </Link>
      <Link
        to='/contact'
        className={`nav-link text-gray-900 dark:text-white ${location.pathname === '/contact' ? 'active' : ''}`}
        onClick={() => setIsDrawerOpen(false)}
      >
        Contact
      </Link>
    </>
  );

  return (
    <header className="bg-stone-100 dark:bg-[rgb(14,16,20)]">
      <div className="max-w-7xl mx-auto px-4 py-6 flex justify-between items-center">
        <div className="text-xl font-semibold text-gray-900 dark:text-white">
          <i className='text-2xl'><span className='text-blue-400  font-bold dark:text-yellow-400'>SE</span>DEV</i>
        </div>
        
        {/* Desktop Navigation */}
        <nav className="hidden md:flex space-x-4">
          <NavLinks />
          <ThemeSwitcher />
        </nav>

        {/* Mobile Menu Button */}
        <button
          className="md:hidden text-gray-900 dark:text-white"
          onClick={toggleDrawer}
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>
      </div>

      {/* Mobile Drawer */}
      <div className={`fixed inset-y-0 right-0 z-50 w-64 bg-stone-100 dark:bg-[rgb(14,16,20)] shadow-lg transform ${isDrawerOpen ? 'translate-x-0' : 'translate-x-full'} transition-transform duration-300 ease-in-out md:hidden`}>
        <div className="p-6">
          <button
            className="absolute top-4 right-4 text-gray-900 dark:text-white"
            onClick={toggleDrawer}
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
          <nav className="mt-8 flex flex-col space-y-4">
            <NavLinks />
            <ThemeSwitcher />
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;
